import React, { useEffect, useRef } from 'react';
import { BookOpen, CheckCheck, Layers, Trophy, ArrowLeft } from 'lucide-react';
import { t } from '../i18n';
import useResultEntrance, { resultMetricDelay, resultRecordDelay, resultRevealStyle } from '../hooks/useResultEntrance';
import './SessionSummary.css';
import './ResultEntrance.css';
import './VocabularySessionResult.css';

const v = (key, values) => t(`vocabulary.${key}`, undefined, values);
const clock = milliseconds => {
  const seconds = Math.max(0, Math.floor((milliseconds || 0) / 1000));
  return `${Math.floor(seconds / 60).toString().padStart(2, '0')}:${(seconds % 60).toString().padStart(2, '0')}`;
};

export default function VocabularySessionResult({ session, onBack }) {
  const headingRef = useRef(null);
  const entrance = useResultEntrance(true, session.id);
  useEffect(() => { headingRef.current?.focus(); window.scrollTo?.(0, 0); }, []);
  const summary = session.summary || {};
  const metrics = [
    ['resultNew', summary.newlyStarted || 0, BookOpen],
    ['resultCompleted', summary.completed || 0, CheckCheck],
    ['resultPresentations', summary.presentations || 0, Layers],
    ['resultPoints', session.scoreGained || 0, Trophy],
  ];
  const reason = session.endReason === 'batch_complete' ? 'batchComplete' : session.availability?.status === 'all_complete' ? 'complete'
    : session.endReason === 'time_limit' ? 'expired' : 'saved';
  return <section className={`session-summary vocabulary-session-result ${entrance.className}`} onAnimationStart={entrance.onAnimationStart} aria-labelledby="vocabulary-result-title">
    <header className="session-summary-header result-reveal">
      <h1 id="vocabulary-result-title" ref={headingRef} tabIndex={-1}>{v('resultTitle')}</h1>
      <p className="session-summary-end-note">{v(reason)}</p>
    </header>
    <div className="session-summary-stats">
      {metrics.map(([label, value, Icon], index) => <div key={label} className="stat-card result-reveal" style={resultRevealStyle(resultMetricDelay(index))} data-result-tone={index}>
        <Icon className="stat-icon" size={22} aria-hidden="true" />
        <div className="stat-value">{value}</div><div className="stat-label">{v(label)}</div>
      </div>)}
    </div>
    <div className="session-summary-time" aria-label={v('resultRecords')}>
      {[
        ['resultTime', clock(session.activeMs)], ['resultWords', summary.cardsStudied || 0], ['resultKnown', summary.alreadyKnown || 0],
      ].map(([label, value], index) => <div key={label} className="record-card result-reveal" style={resultRevealStyle(resultRecordDelay(index))}><div className="record-values"><span>{v(label)}</span><strong>{value}</strong></div></div>)}
    </div>
    <p className="vocabulary-result-explanation result-reveal" style={resultRevealStyle(resultRecordDelay(3))}>{v('resultExplanation')}</p>
    <div className="session-summary-actions"><button type="button" className="btn-back btn-result-home" onClick={onBack}><ArrowLeft size={18} aria-hidden="true" />{v('backBooks')}</button></div>
  </section>;
}
